export enum CountriesEnum {
  MEXICO = 'Mexico',
}
